const TrashIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M3.33334 4.8H12.6667M11.6296 4.8V12.2667C11.6296 12.8 11.1111 13.3333 10.5926 13.3333H5.40742C4.8889 13.3333 4.37038 12.8 4.37038 12.2667V4.8M5.92594 4.8V3.73333C5.92594 3.2 6.44445 2.66667 6.96297 2.66667H9.03705C9.55557 2.66667 10.0741 3.2 10.0741 3.73333V4.8M6.96297 7.46667V10.6667M9.03705 7.46667V10.6667"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TrashIcon;
